var SweepOptionType;
(function (SweepOptionType) {
    // Delete all emails
    SweepOptionType[SweepOptionType["All"] = 0] = "All";
    // Delete all current and future emails
    SweepOptionType[SweepOptionType["AllCurrentAndFuture"] = 1] = "AllCurrentAndFuture";
    // Keep the latest email and delete the rest
    SweepOptionType[SweepOptionType["AllButOne"] = 2] = "AllButOne";
    // Delete emails older than 10 days
    SweepOptionType[SweepOptionType["AllOlderThan"] = 3] = "AllOlderThan";
})(SweepOptionType || (SweepOptionType = {}));
export default SweepOptionType;
//# sourceMappingURL=SweepOptionType.js.map